<template>
  <div class="list">
    <div class="header">
      <div class="l" />
      <div class="r">
        <el-date-picker
          v-if="$route.params.type !== 'video'"
          v-model="daterange"
          type="daterange"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dataChange"
        />
      </div>
    </div>
    <data-table
      :data="tabelData"
      :pagination="true"
      :table-column="$route.params.type === 'video'?tableColumn2:tableColumn1"
      @changeBypagination="tableHandle"
      @sortChange="sortChange"
      @buttonClick="buttonClick"
    />
    <video-dialog
      :dialog-visible.sync="vedioVisible"
      :item="activeVideoItem"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, { registrationStatusList, examVideoStatusList, courseTypeList } from '@/config';
import videoDialog from '@/components/common/videoDialog.vue';

export default {
  name: 'Home',
  components: {
    dataTable,
    videoDialog,
  },
  data() {
    return {
      daterange: null,
      vedioVisible: false,
      activeVideoItem: {},
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        createTimeStart: '',
        createTimeEnd: '',
        sortType: null,
      },
      tabelData: {},
      tableColumn1: [
        {
          key: 'registrationNo',
          label: '订单号',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseName',
          label: '课程名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agencyName',
          label: '机构名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'payAmount',
          label: '支付金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'platformDistributionAmount',
          label: '平台分销',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'agencyDistributionAmount',
          label: '机构分销',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'agencyDistributionStatus',
          label: '机构分销状态',
          width: 'auto',
          dataType: 'component',
          renderProps: { [types.DISTRIBUTION_EXTRACT_ENABLE]: '提取', [types.DISTRIBUTION_EXTRACT_DISABLE]: '未提取', successKey: types.DISTRIBUTION_EXTRACT_ENABLE },
          render: () => 'status',
        },
        {
          key: 'agencyDistributionExtractTime',
          label: '机构分销提取时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'studentDistributionAmount',
          label: '学员分销',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'studentDistributionStatus',
          label: '学员分销状态',
          width: 'auto',
          dataType: 'component',
          renderProps: { [types.DISTRIBUTION_EXTRACT_ENABLE]: '提取', [types.DISTRIBUTION_EXTRACT_DISABLE]: '未提取', successKey: types.DISTRIBUTION_EXTRACT_ENABLE },
          render: () => 'status',
        },
        {
          key: 'studentDistributionExtractTime',
          label: '学员分销提取时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'registrationStatus',
          label: '订单状态',
          width: 'auto',
          dataType: 'function',
          renderProps: '',
          render: (key) => registrationStatusList.filter((item) => item.value === key),
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
          sortable: 'custom',
        },
      ],
      tableColumn2: [
        {
          key: 'userRealName',
          label: '学员姓名',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'agencyName',
          label: '所属名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseName',
          label: '课程名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseType',
          label: '课程类型',
          width: '80px',
          dataType: 'function',
          renderProps: '',
          render: (key) => courseTypeList.filter((item) => item.value === key),
        },
        {
          key: 'chapterName',
          label: '章节名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'auditUserName',
          label: '审核人',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'examScore',
          label: '分数',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'auditAmount',
          label: '审核金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'auditAmountIsExtract',
          label: '是否提取',
          width: 'auto',
          dataType: 'component',
          renderProps: { 0: '未提取', 1: '已提取', successKey: 0 },
          render: () => 'status',
        },
        {
          key: 'auditTime',
          label: '审核时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'examStatus',
          label: '审核状态',
          width: 'auto',
          dataType: 'function',
          renderProps: '',
          render: (key) => examVideoStatusList.filter((item) => item.value === key),
        },
        {
          key: 'control',
          label: '操作',
          width: '100px',
          dataType: 'component',
          renderProps: [
            {
              text: '播放视频', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList() {
      const { type, id } = this.$route.params;
      let result;
      if (type === 'video') {
        this.searchForm.auditUserId = id;
        result = await axClient.registration.pageVideoExamRecordBackend(this.searchForm);
      }
      if (type === 'user') {
        this.searchForm.userId = id;
        this.searchForm.distributionType = 30;
        result = await axClient.distribution.distributionList(this.searchForm);
      }
      if (type === 'teacher') {
        this.searchForm.userId = id;
        this.searchForm.distributionType = 60;
        result = await axClient.distribution.distributionList(this.searchForm);
      }
      if (type === 'agency') {
        this.searchForm.agencyId = id;
        result = await axClient.distribution.distributionList(this.searchForm);
      }
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList();
    },
    // 时间选择
    dataChange(vals) {
      if (vals) {
        const [createTimeStart, createTimeEnd] = vals;
        this.searchForm.createTimeStart = createTimeStart;
        this.searchForm.createTimeEnd = createTimeEnd;
      } else {
        this.searchForm.createTimeStart = '';
        this.searchForm.createTimeEnd = '';
      }
      this.getList();
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        createTime: {
          ascending: 10,
          descending: 20,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.openVideoDialog(item);
          break;
        default:
          break;
      }
    },
    openVideoDialog(item) {
      this.vedioVisible = true;
      this.activeVideoItem.url = item.videoUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  .header {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    .l {
      display: flex;
      align-items: center;
      .label {
        font-weight: 500;
        font-size: 14px;
        margin-right: 12px;
        min-width: 50px;
      }
      .el-select {
        margin-right: 15px;
        flex: 1;
      }
    }
    .r {
      display: flex;
      align-items: center;
      & > .el-button {
        flex: 1;
        margin-left: 15px;
        min-width: auto;
      }
    }
  }
}
</style>
